/* PRDGY collection manual Load More v1 — Dawn SEO duplicate theme.
   Native-first: no auto infinite scroll, no quick-add modal cleanup, no GoKwik/Kwikpass edits. */
(function () {
  if (window.__PRDGY_COLLECTION_LOAD_MORE_V1__) return;
  window.__PRDGY_COLLECTION_LOAD_MORE_V1__ = true;

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function normalizeUrl(url) { return new URL(url, window.location.origin).toString(); }

  function getProductKey(li) {
    var a = li && li.querySelector('a[href*="/products/"]');
    if (!a) return null;
    try { return new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/$/, ''); }
    catch (_) { return a.getAttribute('href'); }
  }

  function getExistingKeys(grid) {
    var set = new Set();
    qsa(grid, ':scope > .grid__item').forEach(function (li) {
      var key = getProductKey(li);
      if (key) set.add(key);
    });
    return set;
  }

  function setStatus(button, text) {
    var wrap = button && button.closest('.prdgy-load-more-wrap');
    var status = wrap && qs(wrap, '[data-prdgy-load-more-status]');
    if (status) status.textContent = text || '';
  }

  function activate() {
    var button = qs(document, '[data-prdgy-load-more]');
    var grid = qs(document, '#ProductGridContainer #product-grid');
    if (!button || !grid || button.dataset.prdgyLoadMoreReady === '1') return;
    button.dataset.prdgyLoadMoreReady = '1';

    document.documentElement.classList.add('prdgy-load-more-enabled');
    var isLoading = false;

    button.addEventListener('click', function () {
      if (isLoading) return;
      var nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl) return;

      isLoading = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      var oldText = button.textContent;
      button.textContent = 'Loading designs…';
      setStatus(button, 'Loading more designs…');

      fetch(normalizeUrl(nextUrl), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = qs(doc, '#ProductGridContainer #product-grid');
          if (!newGrid) throw new Error('Product grid missing in fetched page');

          var existing = getExistingKeys(grid);
          var added = 0;
          qsa(newGrid, ':scope > .grid__item').forEach(function (li) {
            var key = getProductKey(li);
            if (key && existing.has(key)) return;
            if (key) existing.add(key);
            grid.appendChild(document.importNode(li, true));
            added += 1;
          });

          var nextButton = qs(doc, '[data-prdgy-load-more]');
          var next = nextButton && nextButton.getAttribute('data-next-url');
          if (next) {
            button.setAttribute('data-next-url', next);
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = oldText || 'Load more designs';
            setStatus(button, added ? (added + ' fresh designs added — keep exploring.') : 'No new designs found.');
          } else {
            button.removeAttribute('data-next-url');
            button.textContent = 'All designs loaded';
            button.disabled = true;
            button.removeAttribute('aria-busy');
            setStatus(button, 'All designs loaded.');
          }

          try {
            window.dispatchEvent(new CustomEvent('prdgy:collection:loaded', { detail: { added: added } }));
          } catch (_) {}
        })
        .catch(function (err) {
          console.warn('[PRDGY load more] failed', err);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = oldText || 'Load more designs';
          setStatus(button, 'Could not load more. Use page links below.');
          document.documentElement.classList.remove('prdgy-load-more-enabled');
          document.documentElement.classList.add('prdgy-load-more-failed');
        })
        .finally(function () {
          isLoading = false;
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activate);
  else activate();
})();
